import { useNavigate } from "react-router-dom";
import { admin, adminRoute, candidate, canRoute, employer, empRoute } from "../../../globals/route-names";
import { useAuth } from "../../../context/AuthContext";

function HeaderAuthButtons() {
    const navigate = useNavigate();
    const { user, loading, logout } = useAuth();

    const dashboardUrl = () => {
        if (user?.role === "admin") return adminRoute(admin.DASHBOARD);
        if (user?.role === "employer") return empRoute(employer.DASHBOARD);
        return canRoute(candidate.DASHBOARD);
    };

    const handleSignOut = async () => {
        await logout();
        navigate("/", { replace: true });
    };

    if (loading) return null;

    if (user) {
        return (
            <div className="header-nav-btn-section">
                <div className="twm-nav-btn-left">
                    <a className="twm-nav-sign-up" href={dashboardUrl()}>
                        <i className="feather-user" /> Dashboard
                    </a>
                </div>
                <div className="twm-nav-btn-right">
                    <button className="twm-nav-post-a-job" type="button" onClick={handleSignOut}>
                        <i className="feather-log-out" /> Sign Out
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="header-nav-btn-section">
            <div className="twm-nav-btn-left">
                <a className="twm-nav-sign-up" data-bs-toggle="modal" href="#sign_up_popup" role="button">
                    <i className="feather-log-in" /> Sign Up
                </a>
            </div>
            <div className="twm-nav-btn-right">
                <a className="twm-nav-post-a-job" data-bs-toggle="modal" href="#sign_up_popup2" role="button">
                    <i className="feather-log-in" /> Sign In
                </a>
            </div>
        </div>
    );
}

export default HeaderAuthButtons;
